export default __webpack_public_path__ + "static/media/insta-blue.9ffa72bb.svg";